import cn from 'classnames';
import * as React from 'react';

import styles from './ReportsStatus.module.scss';

interface IProps {
  status?: string;
  backgroundColor?: string;
  className?: string;
  tiny?: boolean;
  ellipsis?: boolean;
}

const ReportsStatus = ({ status, backgroundColor, className, tiny, ellipsis }: IProps) => {
  return (
    <div className={cn(styles.status, className, { [styles.tiny]: tiny, [styles.ellipsis]: ellipsis })}>
      <span className={cn(styles.statusDot)} style={{ backgroundColor }} />
      <span className={cn(styles.statusLabel, { [styles.ellipsis]: ellipsis })} title={status}>
        {status}
      </span>
    </div>
  );
};

export default ReportsStatus;
